module.exports = __webpack_public_path__ + "media/app/components/Company/Edit.e9a059a9.svg";